import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'

interface GovUKLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  size?: 's' | 'm' | 'l' | 'xl'
}

export function GovUKLabel({ size, className, children, ...props }: GovUKLabelProps) {
  const classes = ['govuk-label', size && `govuk-label--${size}`, className]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={classes} {...props}>
      {children}
    </label>
  )
}
